import { createSelector } from 'reselect';

const selectRazporpay = (state: any) => state.razporpay;

export const selectCurrentItem = createSelector([selectRazporpay], (razporpay) => razporpay.current);

export const selectListItems = createSelector([selectRazporpay], (razporpay) => razporpay.list);


export const selectItemById = (itemId: any) =>
    createSelector(selectListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCreatedItem = createSelector([selectRazporpay], (razporpay) => razporpay.create);

export const selectUpdatedItem = createSelector([selectRazporpay], (razporpay) => razporpay.update);

export const selectReadItem = createSelector([selectRazporpay], (razporpay) => razporpay.read);

export const selectDeletedItem = createSelector([selectRazporpay], (razporpay) => razporpay.delete);

export const selectSearchedItems = createSelector([selectRazporpay], (razporpay) => razporpay.search);

export const selectItemsCount = createSelector([selectRazporpay], (razporpay) => razporpay.count);

export const selectItemsFilter = createSelector([selectRazporpay], (razporpay) => razporpay.filter);